'use strict';

import { pluginPermissions } from './pluginPermissions';
import Initializer from './components/Initializer';
import PluginIcon from './components/PluginIcon';
import pluginPkg from '../../package.json';
import pluginId from './pluginId';
const name = pluginPkg.strapi.name;
export default {
  register(app) {
    app.addMenuLink({
      to: `/plugins/${pluginId}`,
      icon: PluginIcon,
      intlLabel: {
        id: `${pluginId}.plugin.name`,
        defaultMessage: name
      },
      permissions: [...pluginPermissions.displayPlugin],
      Component: async () => await import('./pages/App/App')
    });
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
      name,
      permissions: Object.values({
        ...pluginPermissions
      }).flat()
    });
  }
};